export default "__VITE_ASSET__DHopqIOp__"